<template>
    <div class="p-5">
        <div class="container-fluid">
            <div class="row size-column">
                <div class="col-xxl-12 col-md-12 box-col-12">
                    <h6 class="mb-4">
                        <b>Last Updated: </b><span style="color: #03c04a">{{ formattedLastUpdated
                        }}<i v-if="last_updated" class="ml-1 fa fa-light fa-check-circle-o"
                                style="color: #03c04a"></i></span>
                    </h6>
                    <h2 class="fw-bold">Icon Menu (IM)</h2>
                    <p>Edit your menu below and don't forget to save your changes</p>
                    <div class="appointment">
                        <div class="row">

                            <div class="header-top p-1" style="border-bottom: 2px solid rgb(236, 236, 236)">
                                <h5 class="m-0 fw-bold">Structure <button class="btn" ref="right" type="button"
                                        data-bs-toggle="m-tooltip" data-bs-trigger="click" data-bs-placement="right"
                                        title="Click on the individual icons to change the image" data-bs-html="true">
                                        <i class="fa fa-question-circle"></i>
                                    </button>
                                </h5>

                                <PrimaryButton :disabled="false" @click="save()"> Save
                                </PrimaryButton>

                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="col-md-12 mt-3 icon-menu">
                                <div class="d-flex mt-4 p-5 gap-5 justify-content-center">
                                    <div class="text-center fw-bold">
                                        <div style="display: flex; flex-direction: column">
                                            <div @click="openGalleryModal('breakfast')" style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                              ">
                                                <img :src="menuIcons[0]" style="
                                                  width: 120px;
                                                  height: 120px;
                                                  object-fit: contain;
                                                  border-radius: 10px;
                                                  border: dashed 1px gray;
                                                " />
                                            </div>
                                        </div>
                                        <span class="mt-5">Breakfast</span>
                                    </div>
                                    <div class="text-center fw-bold">
                                        <div style="display: flex; flex-direction: column">
                                            <div @click="openGalleryModal('regular')" style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                              ">
                                                <img :src="menuIcons[1]" style="
                                                  width: 120px;
                                                  height: 120px;
                                                  object-fit: contain;
                                                  border-radius: 10px;
                                                  border: dashed 1px gray;
                                                " />
                                            </div>
                                        </div>
                                        <span>Regular</span>
                                    </div>
                                    <div class="text-center fw-bold">
                                        <div style="display: flex; flex-direction: column">
                                            <div @click="openGalleryModal('happy_meal')" style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                              ">
                                                <img :src="menuIcons[2]" style="
                                                  width: 120px;
                                                  height: 120px;
                                                  object-fit: contain;
                                                  border-radius: 10px;
                                                  border: dashed 1px gray;
                                                " />
                                            </div>
                                        </div>
                                        <span>Happy Meal<sup>&reg;</sup></span>
                                    </div>
                                    <div class="text-center fw-bold">
                                        <div style="display: flex; flex-direction: column">
                                            <div @click="openGalleryModal('sides')" style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                              ">
                                                <img :src="menuIcons[3]" style="
                                                  width: 120px;
                                                  height: 120px;
                                                  object-fit: contain;
                                                  border-radius: 10px;
                                                  border: dashed 1px gray;
                                                " />
                                            </div>
                                        </div>
                                        <span>Sides</span>
                                    </div>
                                    <div class="text-center fw-bold">
                                        <div style="display: flex; flex-direction: column">
                                            <div @click="openGalleryModal('drinks')" style="
                                                display: flex;
                                                flex-direction: row;
                                                align-items: center;
                                              ">
                                                <img :src="menuIcons[4]" style="
                                                  width: 120px;
                                                  height: 120px;
                                                  object-fit: contain;
                                                  border-radius: 10px;
                                                  border: dashed 1px gray;
                                                " />
                                            </div>
                                        </div>
                                        <span>Drinks</span>
                                    </div>
                                    <ImageComponent @add-image="handleAddImage($event)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import PrimaryButton from '@/components/PrimaryButton.vue';
import CustomDropFile from '@/components/CustomDropFile.vue';
import ImageComponent from "@/components/ImageComponent.vue";
import { getRequest, postRequest, patchRequest } from "@/services/RequestService";
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'

export default {
    components: {
        PrimaryButton,
        CustomDropFile,
        ImageComponent,
    },

    data() {
        return {
            menuIcons: [],
            last_updated: "",
        }
    },
    computed: {
        formattedLastUpdated() {
            const date = new Date(this.last_updated);
            const day = date.getDate();
            const month = date.getMonth() + 1; // Months are 0-indexed
            const year = date.getFullYear();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'pm' : 'am';
            return `${day}/${month}/${year}, ${hours % 12}:${minutes} ${ampm}`;
        },
    },

    methods: {
        async loadIconMenu() {
            try {
                let response = await getRequest("/products/lists/icons");

                if (response.data.success === false) {
                    throw new Error("Error encountered. Please try again.")
                }

                const latestLastUpdated = Math.max(...response.data.data.lists.map(list => new Date(list.last_updated_at).getTime()));
                this.last_updated = new Date(latestLastUpdated).toISOString();

                const iconsData = response.data.data.lists;

                // Extract the menu_icon URLs from the data
                this.menuIcons = iconsData.map(item => item.menu_icon);

                // Extract the menu_icon image_id from the data
                this.image_id = iconsData.map(item => item.image_id);

                console.log("Menu Icons:", this.menuIcons);

            } catch (error) {
                console.error("Error fetching API data:", error);
            }
        },

        openGalleryModal(section) {
            console.log("Open Gallery for:", section);

            document.getElementById("modal_id").value = section;

            var galleryModal = document.getElementById("galleryModal");
            galleryModal.classList.add("show");
            galleryModal.style.display = "block";
        },

        handleAddImage(galleryId) {
            console.log("Added image with ID:", galleryId, "For Section:", galleryId.modalName);

            if (galleryId.modalName == "breakfast") {
                this.menuIcons[0] = galleryId.galleryUrl;
                this.image_id[0] = galleryId.galleryId;
            }
            if (galleryId.modalName == "regular") {
                this.menuIcons[1] = galleryId.galleryUrl;
                this.image_id[1] = galleryId.galleryId;
            }
            if (galleryId.modalName == "happy_meal") {
                this.menuIcons[2] = galleryId.galleryUrl;
                this.image_id[2] = galleryId.galleryId;
            }
            if (galleryId.modalName == "sides") {
                this.menuIcons[3] = galleryId.galleryUrl;
                this.image_id[3] = galleryId.galleryId;
            }
            if (galleryId.modalName == "drinks") {
                this.menuIcons[4] = galleryId.galleryUrl;
                this.image_id[4] = galleryId.galleryId;
            }
        },

        async save() {
            try {
                let post_request = this._headerRequest();

                let response = await postRequest('products/lists/update', post_request);

                if (response.data.success) {
                    this.$swal({
                        icon: response.data.success ? "success" : "error",
                        text: response.data.message,
                        confirmButtonText: "Close",
                    }).then(async () => {
                        location.reload();
                    });
                } else {
                    this.$swal({
                        icon: "error",
                        text: "Incomplete details. Please complete the form.",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#ffbc0d",
                    });
                }

                if (response.data.success === false) {
                    throw new Error('Something\'s not right. Please try again.');
                }

                console.log(response.data);
            } catch (error) {
                console.error('An error occurred:', error);
            }
        },

        _headerRequest() {
            return {
                iconMenu: [
                    {
                        //Regular
                        id: 1,
                        image_id: this.image_id[0],
                    },
                    {
                        //Breakfast
                        id: 2,
                        image_id: this.image_id[1],
                    },
                    {
                        //Happy Meal
                        id: 3,
                        image_id: this.image_id[2],
                    },
                    {
                        //Sides
                        id: 4,
                        image_id: this.image_id[3],
                    },
                    {
                        //Drinks
                        id: 6,
                        image_id: this.image_id[4],
                    },

                ]
            }
        },
    },

    async mounted() {
        new Tooltip(document.body, {
            selector: "[data-bs-toggle='tooltip']",
        }),
            new Tooltip(this.$refs.right),
            await this.loadIconMenu();
    },

    unmounted() {
        let popovers = document.getElementsByClassName('tooltip')
        popovers.forEach(item => {
            item.remove()
        })

    }
}
</script>

<style scoped>
.btn .tooltip .tooltip-inner {
    background-color: #FFBC0D !important;
    color: black !important;
}

.card-body {
    padding: 10px;
}

.icon-menu {
    height: 30rem;
    background-image: url('@/assets/images/admin/header/IM_Structure.svg');
    background-size: contain;
}
</style>
    